<template>
<div>
    <div class="w-400px mg-auto">
        <p class="bold dp-inblock h-30px font-23 mt-20">{{programName}} <br> 수강자 등록하기</p>
        <p class="font-13 pt-20">
            <span class="bold font-16 dp-block">신청자 정보 입력 </span>
            - 수강신청을 위한 신청자 정보를 정확히 입력해 주세요.
        </p>

        <div class="mt-30">
            <table class="clear admin-table-row mb-20 table-auto">
                <thead>
                    <tr v-for="(item, index) of info" :key="index">
                        <th class="w-150px">
                            <!-- Email일때는 구분자가 E-mail@밖에 없으므로 include사용 -->
                            <span v-if="item.item_name.includes('E-mail@')">이메일</span>
                            <span v-else>{{ item.item_name }}</span>
                            <span class="txt-red" v-if="item.necessary_YN === 'Y'">*</span>
                        </th>
                        <!-- 체크박스 -->
                        <td v-if="isCheckbox(item)">
                            <span class="mr-10" v-for="(option, optIdx) of item.option_info.split('&')" :key="optIdx">
                                <input type="checkbox" v-model="item.checkbox[optIdx]"> {{ option }}
                            </span>
                            <p class="font-13 mt-10" v-if="item.item_message">{{ item.item_message }}</p>
                        </td>
                        <!-- 라디오 -->
                        <td v-else-if="isRadio(item)">
                            <span class="mr-10" v-for="(option, optIdx) of item.option_info.split('^')" :key="optIdx">
                                <input type="radio" v-model="item.value" :value="option"> {{ option }}
                            </span>
                            <p class="font-13 mt-10" v-if="item.item_message">{{ item.item_message }}</p>
                        </td>
                        <!-- 서술형 -->
                        <td v-else-if="item.option_info === 'descriptive'">
                            <textarea class="w-100per h-100px" v-model="item.value" placeholder="1000자 이내로 작성하세요." maxlength="1000"></textarea>
                            <p class="font-13 mt-10" v-if="item.item_message">{{ item.item_message }}</p>
                        </td>
                        <!-- 텍스트 (특수항목 포함) -->
                        <td v-else>
                            <input v-if="item.item_name === '비밀번호'" v-model="item.value" type="password" class="w-100per">
                            <input v-else-if="item.item_name === '휴대전화번호'" v-model="item.value" @input="formatAsPhone(item)" maxlength="13" type="text" class="w-100per">
                            <input v-else v-model="item.value" type="text" class="w-100per" :maxlength="item.item_name === '이름' ? 15 : undefined">
                            <span v-if="item.item_name.includes('E-mail@') && item.item_name.replace('E-mail@', '').trim() !== ''">{{ item.item_name.replace("E-mail", "") }}</span>
                            <p class="font-13 mt-10" v-if="item.item_name === '비밀번호'"> ※ 수강신청 내역 확인을 위해 필요합니다.</p>
                            <p class="font-13 mt-10" v-if="item.item_message">{{ item.item_message }}</p>
                        </td>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
    <div class="w-100per txt-center mt-40 mb-40">
        <button class="admin-btn-default" @click="apply()">등록하기</button>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        info: [], // 신청정보 항목을 동적으로 렌더링하기 위한 데이터 (학습자단 reg/input과 동일 구조)

        classList: [],

        programName: '',
        programIdx: '',
        subjectIdx: '',
        pageIdx: ''
    }),

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }

        var oParams = GetUrlParams()
        if (typeof oParams.programIdx === 'undefined') {
            alert('해당 페이지는 주소창으로의 진입이 불가능합니다.')
            window.close()
        }

        this.subjectIdx = oParams.subjectIdx
        this.programIdx = oParams.programIdx
        var params = {
            programIdx: this.programIdx
        }

        this.axios.get(this.axios.root + this.axios.port + '/admin/user-list', {
            params: params
        }).then(res => {
            if (res.data.err === 0) {
                this.classList = res.data.classList
                this.pageIdx = this.classList[0].idx_itm_sugang_page_main
            } else {
                alert(res.data.result)
            }
        })

        // 신청정보 항목 조회 후 학습자단 reg/input과 동일하게 동적 입력폼 구성
        var infoParams = {
            subjectIdx: this.subjectIdx
        }
        this.axios.get(this.axios.root + this.axios.port + '/admin/user-list-info', {
            params: infoParams
        }).then(res => {
            if (res.data.err === 0) {
                for (var item of res.data.infoList) {
                    if (item.use_YN === 'Y') {
                        if (item.option_info.split('^').length > 1) {
                            item['value'] = item.option_info.split('^')[0]
                        } else {
                            item['value'] = ''
                        }

                        if (item.option_info.split('&').length > 1) {
                            item.checkbox = []
                        }

                        this.info.push(item)
                    }
                }
            } else {
                alert(res.data.result)
            }
        })
    },

    methods: {
        isCheckbox(item) {
            return item.option_info && item.option_info !== 'direct' && item.option_info !== 'descriptive' && item.option_info.indexOf('&') !== -1
        },
        isRadio(item) {
            return item.option_info && item.option_info !== 'direct' && item.option_info !== 'descriptive' && item.option_info.indexOf('^') !== -1
        },
        formatAsPhone(item) {
            let value = item.value.replace(/\D/g, '') // 숫자만 남기기

            // 하이픈 포맷 적용
            if (value.length > 3 && value.length <= 7) {
                value = value.replace(/(\d{3})(\d+)/, '$1-$2')
            } else if (value.length > 7) {
                value = value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
            }

            this.$set(item, 'value', value)
        },

        // 관리자가 수강자 직접 등록하기
        apply() {
            var applyData = {
                name: '',
                email: '',
                password: '',
                mobile: '',
                number: '',
                position: '',
                dept: '',
                company: '',
                point: ''
            }
            var options = [] // 커스텀 항목 (optionName/optionContents 1~15)
            var hasPasswordItem = false

            for (var item of this.info) {
                // 체크박스 항목 값 취합 (학습자단 reg/input과 동일)
                if (item.option_info.indexOf('&') !== -1) {
                    var temp = item.option_info.split('&')
                    var checkboxIdx = 0
                    item.value = ''

                    for (let idx = 0; idx < temp.length; idx++) {
                        if (item.checkbox[idx] === true && checkboxIdx === 0) {
                            item.value = item.value + temp[idx]
                            checkboxIdx++
                        } else if (item.checkbox[idx] === true) {
                            item.value = item.value + ' ' + temp[idx]
                        }
                    }
                }

                if (item.item_name === '이름') {
                    applyData.name = item.value
                } else if (item.item_name === '비밀번호') {
                    hasPasswordItem = true
                    if (!item.value || item.value.trim() === '') {
                        alert('비밀번호를 입력해주세요.')
                        return false
                    }
                    // 비밀번호 형식 검증 (학습자단 reg/input과 동일 규칙)
                    var eng_exp = /[^A-Za-z]/gi
                    if (!eng_exp.test(item.value)) {
                        alert('비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가')
                        return false
                    }
                    var num_exp = /^[0-9]*$/
                    if (num_exp.test(item.value)) {
                        alert('비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가')
                        return false
                    }
                    var passRegex = /^[A-Za-z0-9+]{8,12}$/
                    if (!passRegex.exec(item.value)) {
                        alert('비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가')
                        return false
                    }
                    applyData.password = item.value
                } else if (item.item_name.includes('E-mail@')) {
                    var emailRegex = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/

                    if (item.item_name.replace('E-mail@', '').trim() === '') {
                        if (!emailRegex.exec(item.value)) {
                            alert('정확한 이메일을 입력해 주세요.')
                            return false
                        }
                        applyData.email = item.value
                    } else {
                        // 도메인 고정형: 아이디만 입력받고 도메인 자동 결합
                        if (!emailRegex.exec(item.value + item.item_name.replace('E-mail', ''))) {
                            alert('정확한 이메일을 입력해 주세요.')
                            return false
                        }
                        applyData.email = item.value + item.item_name.replace('E-mail', '')
                    }
                } else if (item.item_name === '사번') {
                    applyData.number = item.value
                } else if (item.item_name === '휴대전화번호') {
                    // 미입력 시 통과(필수 여부는 아래 필수값 체크에서 판단), 입력 시 번호 포맷 검사
                    if (item.value && item.value.trim() !== '') {
                        const phoneRegex = /^\d{3}-\d{4}-\d{4}$/ // 000-0000-0000 형식
                        if (!phoneRegex.test(item.value)) {
                            alert('휴대전화번호는 숫자 11자리를 정확히 입력해 주세요.')
                            return false
                        }
                    }
                    applyData.mobile = item.value
                } else if (item.item_name === '직급') {
                    applyData.position = item.value
                } else if (item.item_name === '공인시험점수') {
                    applyData.point = item.value
                } else if (item.item_name === '부서') {
                    applyData.dept = item.value
                } else if (item.item_name === '회사') {
                    applyData.company = item.value
                } else {
                    // 커스텀 항목은 optionName/optionContents로 저장 (학습자단 reg/input과 동일)
                    if (options.length < 15) {
                        options.push({
                            name: item.item_name,
                            contents: item.value
                        })
                    }
                }

                // 필수값 체크
                if (item.necessary_YN === 'Y' && (!item.value || item.value.trim() === '')) {
                    if (item.item_name.includes('E-mail@')) {
                        alert('이메일을 입력해주세요.')
                        return false
                    } else {
                        alert(item.item_name + '을(를) 입력해주세요.')
                        return false
                    }
                }
            }

            if (!applyData.name || applyData.name.trim() === '') {
                alert('이름을 입력해주세요.')
                return false
            }
            if (!applyData.email || applyData.email.trim() === '') {
                alert('이메일을 입력해주세요.')
                return false
            }
            if (!hasPasswordItem) {
                // 신청정보 항목에 비밀번호가 없는 경우 학습자단과 동일하게 기본 비밀번호 사용
                applyData.password = 'carrot1321'
            }

            var param0 = {
                classList: [],
                programIdx: this.programIdx
            }

            for (var classItem of this.classList) {
                if (classItem.subject_idx === Number(this.subjectIdx)) {
                    param0['classList'].push({
                        classIdx: classItem.class_idx,
                        className: classItem.class_name,
                        idxItmSugangPageMain: classItem.idx_itm_sugang_page_main,
                        idxItmSugangProgram: this.programIdx,
                        subjectList: [{
                            subjectIdx: classItem.subject_idx,
                            subjectName: classItem.subject_name
                        }]
                    })
                    break
                }
            }

            param0['email'] = applyData.email
            param0['idxItmSugangPageMain'] = this.pageIdx
            param0['mobile'] = applyData.mobile
            param0['name'] = applyData.name
            param0['password'] = applyData.password
            param0['number'] = applyData.number
            param0['position'] = applyData.position
            param0['dept'] = applyData.dept
            param0['company'] = applyData.company
            param0['point'] = applyData.point

            for (var [optIdx, option] of options.entries()) {
                param0['optionName' + (optIdx + 1).toString()] = option.name
                param0['optionContents' + (optIdx + 1).toString()] = option.contents
            }

            if (this.classList.length !== 0) {
                param0['type'] = 'Y'
            } else {
                param0['type'] = 'N'
            }

            this.axios
                .post(this.axios.root + this.axios.port + "/user/check-subjectdup", param0)
                .then((res) => {
                    if (res.data.err === 0) {
                        this.axios.post(this.axios.root + this.axios.port + '/admin/user-regist', param0)
                            .then(res => {
                                if (res.data.err === 0) {
                                    // 정원 마감으로 실패(F·C)·대기(Y) 처리된 클래스는 따로 안내 RHPE-12632
                                    const subjectList = res.data.subjectList || []
                                    const failNames = subjectList.filter(item => item.status === 'F' || item.status === 'C').map(item => item.subjectName)
                                    const waitNames = subjectList.filter(item => item.status === 'Y').map(item => item.subjectName)
                                    let message = '등록되었습니다.'
                                    if (failNames.length > 0) message += `\n\n${failNames.join(',')} 은(는) 정원이 마감되어 '신청실패'로 등록되었습니다.`
                                    if (waitNames.length > 0) message += `\n\n${waitNames.join(',')} 은(는) 정원이 마감되어 '대기자'로 등록되었습니다.`
                                    alert(message)
                                    window.close()
                                } else {
                                    alert(res.data.result)
                                    return false
                                }
                            })
                    } else {
                        alert(res.data.result)
                        return false
                    }
                })
        }
    }
}
</script>
